var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22 6.404v11.193c0 .187-.085.316-.254.384a.514.514 0 0 1-.459-.093L17 13.753V16.8c0 .331-.122.614-.366.848a1.23 1.23 0 0 1-.884.352H3.25a1.23 1.23 0 0 1-.884-.352A1.133 1.133 0 0 1 2 16.8V7.2c0-.33.122-.614.366-.848A1.23 1.23 0 0 1 3.25 6h12.5c.345 0 .64.118.884.352.244.234.366.517.366.848v3.047l4.287-4.134c.104-.106.257-.138.46-.094.168.069.253.197.253.385z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.051f1e0a9e108a1294301d297b3e8af4.svg";
export { ForwardRef as ReactComponent };